import React from 'react';

import './ProgressBar.css';

export const ProgressBar = props => {
  return (
    <div className="progress-bar-container">
      <div className="container-progress">
        <p>{props.data.answeredQuestions}/{props.data.totalQuestions}</p>
      </div>
      <div style={{ width: props.data.percent + '%' }} className="progress-bar" />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/screens/Question/components/ProgressBar/ProgressBar.js